module.exports = __webpack_public_path__ + "img/local_post_office.ddadffcc.svg";